import md5 from "js-md5";
import { getCurrentUser, getUserSuccRoleAndCompany } from "@/api";
import { apiCallback } from "@/utils";
import { getConfigNoUserId } from "@/api/common";
import { Notification } from "element-ui";

const state = {
    userId: "",
    openId: "",
    loginState: "",
    token: "",
    username: "",
    userphone: "",
    userEmail: "",
    qqNumber: "",
    avatar: "",
    loginId: "personal", //登陆身份：认证企业或个人
    uAccount: 0,
    cAccount: 0,
    accountUser: null,
    accountCompany: null,
    roles: [],
    cid: null,
    inviteCode: "",
    clientUseComapnyList: [], //客户公司可用列表
    updateNotesKnowConfig: {}, // 更新公告已读配置
    experiences: [], // 当前用户全部的体验权限列表（个人和公司身份的体验权限）
    allExperiences: {}, // 所有用户的体验权限列表（个人和公司身份的体验权限）
    companyHasStowage: false, // 公司是否默认订阅配载
    allUserRole: [], // 用户所有角色(切换身份时的角色列表)
};

const mutations = {
    // 设置userId
    editUserId(state, payload) {
        state.userId = payload;
    },
    editOpenId(state, payload) {
        state.openId = payload;
    },
    // 设置登录状态
    editLoginState(state, payload) {
        state.loginState = payload;
    },
    editToken(state, payload) {
        state.token = payload;
    },
    editUsername(state, payload) {
        state.username = payload;
    },
    editUserphone(state, payload) {
        state.userphone = payload;
    },
    editUserEmail(state, payload) {
        state.userEmail = payload;
    },
    editQQNumber(state, payload) {
        state.qqNumber = payload;
    },
    editAvatar(state, payload) {
        state.avatar = payload;
    },
    editLoginId(state, payload) {
        state.loginId = payload;
    },
    edituAccount(state, payload) {
        state.uAccount = payload;
    },
    editcAccount(state, payload) {
        state.cAccount = payload;
    },
    editAccountUser(state, payload) {
        state.accountUser = payload;
        state.uAccount = payload.balance;
    },
    editAccountCompany(state, payload) {
        state.accountCompany = payload;
        state.cAccount = payload.balance;
    },
    editCid(state, payload) {
        state.cid = payload;
    },
    editInviteCode(state, payload) {
        state.inviteCode = payload;
    },
    editRoles(state, payload) {
        state.roles = payload;
    },
    editClientUseComapnyList(state, payload) {
        state.clientUseComapnyList = payload;
    },
    editUpdateNotesKnowConfig(state, payload) {
        state.updateNotesKnowConfig = payload;
    },
    editExperiences(state, payload) {
        state.experiences = payload;
    },
    editAllExperiences(state, payload) {
        state.allExperiences = payload;
    },
    editCompanyHasStowage(state, payload) {
        state.companyHasStowage = payload;
    },
    editAllUserRole(state, payload) {
        state.allUserRole = payload;
    },
};

const actions = {
    updateUserInfo({ state, commit }) {
        return new Promise((resolve, reject) => {
            getCurrentUser()
                .then((res) => {
                    const data = apiCallback(res);
                    const {
                        userName,
                        phone,
                        avatar,
                        id,
                        role,
                        token,
                        invitationCode,
                        roles,
                        company,
                        email,
                    } = data || {};
                    var md5Role = md5(role + "/" + id);
                    var localtype = md5("role");
                    localStorage.setItem(localtype, md5Role);
                    if (!state.token) {
                        commit("editToken", token);
                        localStorage.setItem("token", token);
                    }
                    if (!state.userId) {
                        commit("editUserId", id);
                    }
                    commit("editInviteCode", invitationCode);
                    commit("editUsername", userName);
                    commit("editUserphone", phone);
                    commit("editUserEmail", email);
                    commit("editRoles", roles);
                    var imageUrl = avatar
                        ? avatar
                        : require("@/assets/img/icon_user.png");
                    commit("editAvatar", imageUrl);
                    if (company) {
                        commit(
                            "editCompanyHasStowage",
                            company.isStowage === 1,
                        );
                    } else {
                        commit("editCompanyHasStowage", false);
                    }
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateInviteCode({ commit }) {
        const breakPathArr = ["wxtruckmap", "wxshipmap", "wxlogin"]; // 小程序界面，不需要更新邀请码
        const needBreak = breakPathArr.some((path) => {
            return window.location.href.indexOf(path) !== -1;
        });
        if (!needBreak) {
            getCurrentUser().then((res) => {
                const data = apiCallback(res);
                commit("editRoles", data.roles);
                commit("editInviteCode", data.invitationCode);
                if (data.company) {
                    commit(
                        "editCompanyHasStowage",
                        data.company.isStowage === 1,
                    );
                } else {
                    commit("editCompanyHasStowage", false);
                }
            });
        }
    },
    updateExperiences({ state, commit }) {
        return new Promise((resolve) => {
            getConfigNoUserId({
                dictKey: "web_fangcangwang_experience_users_new",
            })
                .then((res) => {
                    const data = apiCallback(res);
                    if (data.dictValue) {
                        const parseValue = JSON.parse(data.dictValue);
                        commit("editAllExperiences", parseValue);
                        // 先看一下个人身份的体验权限，再加上公司身份的体验权限
                        const personalContent =
                            parseValue[state.userphone]?.experienceContent;
                        const personalExperiences = Array.isArray(
                            personalContent,
                        )
                            ? personalContent
                            : [];
                        let companyExperiences = [];
                        if (
                            Array.isArray(state.allUserRole) &&
                            state.allUserRole.length
                        ) {
                            // 遍历所有公司身份，获取公司身份的体验权限
                            state.allUserRole.forEach((item) => {
                                const companyContent =
                                    parseValue[item.cid]?.experienceContent;
                                if (Array.isArray(companyContent)) {
                                    companyExperiences.push(...companyContent);
                                }
                            });
                        }
                        // 合并个人和公司身份的体验权限并去重
                        const curUserExperiences = [
                            ...personalExperiences,
                            ...companyExperiences,
                        ];
                        const uniqueExperiences = [
                            ...new Set(curUserExperiences),
                        ];
                        commit("editExperiences", uniqueExperiences);
                        resolve(uniqueExperiences);
                    } else {
                        commit("editExperiences", []);
                        commit("editAllExperiences", {});
                        resolve([]);
                    }
                })
                .catch((err) => {
                    if (err.message === "数据不存在，请检查dictKey是否有误") {
                        Notification.closeAll();
                    }
                    commit("editExperiences", []);
                    commit("editAllExperiences", {});
                    resolve([]);
                });
        });
    },
    updateAllUserRole({ state, commit }) {
        return new Promise((resolve) => {
            getUserSuccRoleAndCompany()
                .then((res) => {
                    const data = apiCallback(res);
                    commit("editAllUserRole", data);
                    resolve(data);
                })
                .catch(() => {
                    resolve([]);
                });
        });
    },
};

const getters = {
    clientCompanyListByName(state) {
        return (name) => {
            //根据公司名称查询公司列表
            return name
                ? state.clientUseComapnyList.filter((item) => {
                      return item.clientName.indexOf(name) !== -1;
                  })
                : state.clientUseComapnyList;
        };
    },
    curUserRoleExperiences(state) {
        return state.allUserRole.reduce((acc, item) => {
            const { cid } = item;
            return {
                ...acc,
                [cid]: state.allExperiences[cid]?.experienceContent || [],
            };
        }, {});
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
